{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} gesprekken geselecteerd",
    "NONE": "Geen",
    "CLEAR_SELECTION": "Clear",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Ja",
    "CANCEL": "Annuleren",
    "SEARCH_INPUT_PLACEHOLDER": "Zoeken",
    "ASSIGN_AGENT_TOOLTIP": "Agent toewijzen",
    "ASSIGN_TEAM_TOOLTIP": "Team toewijzen",
    "ASSIGN_SUCCESFUL": "Gesprekken succesvol toegewezen.",
    "ASSIGN_FAILED": "Toewijzen van gesprekken mislukt, probeer het opnieuw.",
    "RESOLVE_SUCCESFUL": "Gesprekken succesvol opgehaald.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Gesprekken die op deze pagina zichtbaar zijn, zijn alleen geselecteerd.",
    "UPDATE": {
      "CHANGE_STATUS": "Status wijzigen",
      "SNOOZE_UNTIL": "Sluimeren",
      "UPDATE_SUCCESFUL": "Gespreksstatus succesvol bijgewerkt.",
      "UPDATE_FAILED": "Update van gesprekken mislukt, probeer het opnieuw."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Labels toewijzen",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Geselecteerde labels toewijzen",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Labels met succes toegewezen.",
      "ASSIGN_FAILED": "Toewijzen van labels mislukt, probeer het opnieuw.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Geen",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Toewijzen team mislukt, probeer het opnieuw."
    }
  }
}
